"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var fi_1 = require("react-icons/fi");
var io5_1 = require("react-icons/io5");
var react_i18next_1 = require("react-i18next");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./index.scss");
var SearchModal_1 = require("../SearchModal");
var network_1 = require("../../network");
var react_router_1 = require("react-router");
var Product_1 = require("./Product");
var utils_1 = require("../../utils/utils");
var Search = function (_a) {
    var className = _a.className;
    var location = (0, react_router_1.useLocation)();
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var _c = (0, react_1.useState)(false), showSearchModal = _c[0], setShowSearchModal = _c[1];
    var _d = (0, react_1.useState)(''), search = _d[0], setSearch = _d[1];
    var searchRef = (0, react_1.useRef)(null);
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var _e = (0, network_1.useGetRestaurantMenu)({
        id: restaurantId,
        type: type,
        options: { enabled: !!restaurantId },
    }).data, menus = _e === void 0 ? [] : _e;
    var categories = (0, react_1.useMemo)(function () { return menus.flatMap(function (menu) { return __spreadArray([], menu.categories, true); }); }, [restaurantId]);
    var dishes = (0, react_1.useMemo)(function () { return categories.flatMap(function (menu) { return __spreadArray([], menu.dishes, true); }); }, [restaurantId]);
    var filteredDishes = (0, react_1.useMemo)(function () { return (search ? dishes.filter(function (dish) { return (dish.title || '').toLowerCase().includes(search); }) : []); }, [search]);
    var dishesLength = filteredDishes.length;
    var onChangeSearch = function (e) {
        setSearch(e.target.value.toLowerCase());
    };
    var onClose = function () {
        setShowSearchModal(false);
        setSearch('');
    };
    var onChangeMainSearch = function (e) {
        setSearch(e.target.value.toLowerCase());
        setShowSearchModal(true);
    };
    var onOpenSearch = function () { return setShowSearchModal(true); };
    (0, react_1.useEffect)(function () {
        if (searchRef.current) {
            searchRef.current.focus();
            searchRef.current.scrollIntoView();
        }
    }, [showSearchModal, searchRef]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('input-search', className) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "input-search-icon" }, { children: (0, jsx_runtime_1.jsx)(fi_1.FiSearch, { size: 20 }) })), (0, jsx_runtime_1.jsx)("input", { type: "text", value: "", onChange: onChangeMainSearch, onClick: onOpenSearch, id: "default-search", className: "input-search-input", placeholder: t('Search items') })] })), (0, jsx_runtime_1.jsxs)(SearchModal_1.SearchModal, __assign({ onClose: onClose, showSearchModal: showSearchModal }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('input-search input-search-modal', className) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "input-search-icon input-search-modal-icon" }, { children: (0, jsx_runtime_1.jsx)(io5_1.IoArrowBack, { size: 22, cursor: "pointer", onClick: onClose }) })), (0, jsx_runtime_1.jsx)("input", { autoFocus: true, defaultValue: search, ref: searchRef, type: "search", id: "default-search", className: "input-search-input input-search-modal-input", placeholder: t('Search items'), onChange: onChangeSearch }), dishesLength > 0 && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-search-modal-count" }, { children: [dishesLength, " ", i18n.language === 'ru' ? (0, utils_1.pluralize)(dishesLength, 'результат', 'результата', 'результатов') : t('result', { count: dishesLength }), " ", t('result-for'), " \"", search, "\""] })))] })), dishesLength > 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "input-search-modal-products" }, { children: filteredDishes.map(function (dish) {
                            return (0, jsx_runtime_1.jsx)(Product_1.SearchProduct, { dish: dish }, dish.id);
                        }) })))] }))] }));
};
exports.Search = Search;
